import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { get } from 'lodash-es';
import {
  videoCommentAddRequestAction,
  videoCommentRemoveRequestAction,
  videoCommentsFetchRequestAction,
} from './actions';
import {
  getVideoCommentsFormAddingSelector,
  getVideoCommentsFormSuccessSelector,
  getVideoCommentsListLoadingSelector,
  getVideoCommentsSelector,
} from 'common/selectors/video-comments';
import { getVideoIdSelector } from '../selectors';
import { getUserId } from 'utils/website';
import { NewCommentFormDecorated } from './fragments/new-comment-form';
import { CommentsList } from './fragments/comments-list';
import { NewCommentButton } from './fragments/new-comment-button';
import { LoadingSpinner } from 'components/loading-spinner';
import { commentsFeatureSelector } from 'common/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

let VideoComments = class extends React.Component {
  state = {
    showForm: false,
  };

  componentDidMount() {
    if (this.props.videoId && get(this.props.commentsFeature, 'enabled')) {
      this.props.requestFetchComments(this.props.videoId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.videoId && this.props.videoId !== prevProps.videoId && get(this.props.commentsFeature, 'enabled')) {
      this.props.requestFetchComments(this.props.videoId);
    }
  }

  toggleShowForm = () => {
    const show = this.state.showForm;
    this.setState({
      showForm: !show,
    });
  };

  formSubmit = (values) => {
    this.toggleShowForm();
    this.props.requestAddComment(this.props.videoId, values.name, values.email, values.content);
  };

  render() {
    return (
      <div className={this.props.className}>
        {this.state.showForm ? (
          <NewCommentFormDecorated
            onSubmit={this.formSubmit}
            textBox={get(this.props.commentsFeature, 'textBox')}
            withUserFields={!this.props.userId && true}
            toggleFormAction={this.toggleShowForm}
          />
        ) : (
          <NewCommentButton toggleFormAction={this.toggleShowForm} />
        )}

        {this.props.loading && <LoadingSpinner />}

        {!this.state.showForm && this.props.showSuccessMsg && (
          <div className="ct-comment-added">
            <FontAwesomeIcon icon={faCheck} />
            {this.props.t('thanks_for_comment')}
          </div>
        )}

        <CommentsList
          comments={this.props.comments}
          onDelete={(commentId) => this.props.requestRemoveComment(this.props.videoId, commentId)}
          userId={this.props.userId}
        />
      </div>
    );
  }
};

VideoComments.propTypes = {
  className: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  requestAddComment: (videoId, email, name, content) =>
    dispatch(videoCommentAddRequestAction(videoId, email, name, content)),
  requestFetchComments: (videoId) => dispatch(videoCommentsFetchRequestAction(videoId)),
  requestRemoveComment: (videoId, commentId) => dispatch(videoCommentRemoveRequestAction(videoId, commentId)),
});

const mapStateToProps = (state) => ({
  videoId: getVideoIdSelector(state),
  userId: getUserId(),
  loading: getVideoCommentsListLoadingSelector(state),
  adding: getVideoCommentsFormAddingSelector(state),
  showSuccessMsg: getVideoCommentsFormSuccessSelector(state),
  comments: getVideoCommentsSelector(state),
  commentsFeature: commentsFeatureSelector(state),
});

const mergeProps = (stateProps, dispatchProps, props) => ({
  ...stateProps,
  ...dispatchProps,
  ...props,
});

VideoComments = compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps, mergeProps))(VideoComments);

export { VideoComments };
